<template>
  <v-modal :animation="!screen.breakPoint.tabPort ? 'slide-up' : 'slide-down'" fit-content v-model="vModel" handle-click-bg>
    <template #header>
      {{ $t('components.DeclinePartnerComment.title') }}
    </template>

    <div class="mb-2">{{ $t('components.DeclinePartnerComment.description') }}</div>
    <v-input :value="comment" @input="(e) => $emit('change', e)" :placeholder="$t('components.DeclinePartnerComment.title')"></v-input>

    <template #footer>
      <div class="d-flex justify-end">
        <v-button class="mr-2" @click="$emit('cancel')" inline>{{$t('widgets.ConfirmModal.cancel')}}</v-button>
        <v-button color="success" @click="$emit('confirm')" :disabled="!comment || comment.length < 1">{{$t('widgets.ConfirmModal.confirm')}}</v-button>
      </div>
    </template>
  </v-modal>
</template>

<script>
import vModal from '@/ui/modals/vModal'
import vInput from '@/ui/controls/vInput'
import vButton from '@/ui/controls/vButton'

import screen from '@/mixins/screen'

export default {
  mixins: [screen],

  props: {
    value: {
      type: Boolean,
      default: false
    },

    comment: {
      type: String,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    vModal,
    vInput,
    vButton
  },

  computed: {
    vModel: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
